export function SiigoIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4C7.58 4 4 6.69 4 10c0 2.05 1.33 3.84 3.35 5C6.5 16.3 5 17.5 5 17.5s3.13 2.5 7 2.5 7-2.5 7-2.5-1.5-1.2-2.35-2.5C18.67 13.84 20 12.05 20 10c0-3.31-3.58-6-8-6z"
        fill="#111"
      />
      <path
        d="M12 4C7.58 4 4 6.69 4 10c0 2.05 1.33 3.84 3.35 5C6.5 16.3 5 17.5 5 17.5s3.13 2.5 7 2.5 7-2.5 7-2.5-1.5-1.2-2.35-2.5C18.67 13.84 20 12.05 20 10c0-3.31-3.58-6-8-6z"
        fill="none"
        stroke="#111"
        strokeWidth="0.5"
      />
      <text x="7.5" y="13.5" fill="#fff" fontSize="6" fontWeight="bold" fontFamily="sans-serif">S</text>
    </svg>
  );
}
